import 'regenerator-runtime/runtime'
import {
  SurveyInstanceExecutionServicePromiseClient,
  GetNextQuestionRequest,
  setRequest,
} from '@utils/index'

type Params = GetNextQuestionRequest.AsObject

const {
  REACT_APP_QUERY_HOST = 'https://staging.pandolink.com',
  REACT_APP_QUERY_PORT = '443',
} = process.env

export const getNextQuestion = async (params: Params, accessToken: string) => {
  const service = new SurveyInstanceExecutionServicePromiseClient(
    `${REACT_APP_QUERY_HOST}:${REACT_APP_QUERY_PORT}`
  )

  const request = setRequest(new GetNextQuestionRequest(), params)

  const result = await service.getNextQuestion(request, {
    authorization: `Bearer ${accessToken}`,
  })

  return result
}
